import {
  GET_DEFAULT_ZEBRA_PRINTERS_REQUEST,
  GET_DEFAULT_ZEBRA_PRINTERS_SUCCESS,
  GET_DEFAULT_ZEBRA_PRINTERS_FAILURE,
  PRINT_ZEBRA_LABEL_REQUEST,
  PRINT_ZEBRA_LABEL_SUCCESS,
  PRINT_ZEBRA_LABEL_FAILURE
} from '../../constants/zebra-print'

const initialState = {
  defaultPrinters: [],
  loading: false,
  printingLabel: false,
  error: null
}

const zebraPrintReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DEFAULT_ZEBRA_PRINTERS_REQUEST:
      return {
        ...state,
        loading: true,
        defaultPrinters: [],
        error: null
      }
    case GET_DEFAULT_ZEBRA_PRINTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        defaultPrinters: action.payload,
        error: null
      }
    case GET_DEFAULT_ZEBRA_PRINTERS_FAILURE:
      return {
        ...state,
        loading: false,
        defaultPrinters: [],
        error: action.payload
      }
    case PRINT_ZEBRA_LABEL_REQUEST:
      return {
        ...state,
        loading: true,
        printingLabel: true,
        error: null
      }
    case PRINT_ZEBRA_LABEL_SUCCESS:
      return {
        ...state,
        loading: false,
        printingLabel: false,
        error: null
      }
    case PRINT_ZEBRA_LABEL_FAILURE:
      return {
        ...state,
        loading: false,
        printingLabel: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default zebraPrintReducer
